import { useState } from "react";

export interface FaqItem {
  question: string;
  answer: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpen?: number | null;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
              >
                <span
                  className={`font-heading font-semibold text-base md:text-lg transition-colors ${
                    isOpen ? "text-primary-700" : "text-foreground-950 group-hover:text-primary-700"
                  }`}
                >
                  {item.question}
                </span>
                <span
                  className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-colors ${
                    isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                  }`}
                >
                  <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`} aria-hidden="true"></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="pb-6 pr-10">
                <p className="text-sm md:text-base leading-relaxed text-foreground-600">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}